import { useSyncExternalStore } from 'react'
import {
  getListToolbarPosition,
  subscribeListToolbarPosition,
  type ListToolbarPosition,
} from '../utils/listToolbarPosition'

/**
 * Wo die **Listen-Werkzeug-Pille** steht — für jede offene Liste dieselbe
 * Stelle (`utils/listToolbarPosition.ts`).
 *
 * @example
 * const position = useListToolbarPosition()
 */
export function useListToolbarPosition(): ListToolbarPosition {
  return useSyncExternalStore(subscribeListToolbarPosition, getListToolbarPosition, getListToolbarPosition)
}
